import { Flex, Text } from "@chakra-ui/react";
import confetti from "canvas-confetti";
import React from "react";
import { useCallback, useRef } from "react";
import "./SingaporeGlow.css";

function SingaporeGlow() {
  const triggerRef = useRef(null);

  const celebrate = useCallback(() => {
    if (!triggerRef.current) return;

    const bounds = triggerRef.current.getBoundingClientRect();
    const origin = {
      x: (bounds.left + bounds.width / 2) / window.innerWidth,
      y: (bounds.top + bounds.height / 2) / window.innerHeight,
    };
    const colors = ["#d9252a", "#ffffff"];

    confetti({
      particleCount: 36,
      spread: 64,
      startVelocity: 28,
      ticks: 120,
      origin,
      colors,
      disableForReducedMotion: true,
    });

    window.setTimeout(() => {
      confetti({
        particleCount: 24,
        spread: 100,
        startVelocity: 18,
        ticks: 100,
        origin,
        colors,
        scalar: 0.9,
        disableForReducedMotion: true,
      });
    }, 70);
  }, []);

  return (
    <button
      ref={triggerRef}
      className="singapore-trigger"
      type="button"
      aria-label="Celebrate Singapore"
      onClick={celebrate}
    >
      <span className="singapore-trigger__word" data-text="Singapore">Singapore</span>
    </button>
  );
}

export default function Footer() {
  return (
    <Flex as="footer" w="100%" maxW="36.375rem" px={{ base: "1.5rem", md: "0" }} py="6" color="rgba(0, 0, 0, 0.42)" fontFamily="Inter, Arial, sans-serif" fontSize="0.75rem">
      <Text>© {new Date().getFullYear()} Fabian Chua <span aria-hidden="true">·</span>{" "}<SingaporeGlow /></Text>
    </Flex>
  );
}
